<script setup lang="ts">
import Dialog from 'primevue/dialog';
import Tabs from 'primevue/tabs';
import TabList from 'primevue/tablist';
import Tab from 'primevue/tab';
import TabPanels from 'primevue/tabpanels';
import TabPanel from 'primevue/tabpanel';
import DarkModeToggle from './general/DarkModeToggle.vue';
import LanguageSelect from './general/LanguageSelect.vue';
import MapColorMode from './general/MapColorMode.vue';
import MapStyleSelect from './map/MapStyleSelect.vue';
import DisplayLogo from './about/DisplayLogo.vue';
import VersionInfo from './about/VersionInfo.vue';
import { useLanguageStore } from 'shared/translations/stores/languageStore';
import { storeToRefs } from 'pinia';
import ReleaseNoteList from 'shared/releaseNotes/components/ReleaseNoteList.vue';
import { onMounted } from 'vue';
import { useRefreshReleaseNoteStore } from '@/releaseNotes/stores/refreshReleaseNoteStore';
import { useReleaseNoteStore } from 'shared/releaseNotes/stores/releaseNoteStore';

const languageStore = useLanguageStore();
const { translations } = storeToRefs(languageStore);

const visible = defineModel<boolean>('visible');

const refreshReleaseNoteStore = useRefreshReleaseNoteStore();
const releaseNoteStore = useReleaseNoteStore();

const { list: notes } = storeToRefs(releaseNoteStore);

onMounted(async () => {
  await refreshReleaseNoteStore.initialize();
});

</script>

<template>
  <Dialog v-model:visible="visible" :header="translations.generic.settings" :modal="false" :draggable="false"
    :closable="true" content-class="h-full" class="settings-dialog">
    <Tabs value="general">
      <TabList>
        <Tab value="general">{{ translations.settings.general.title }}</Tab>
        <Tab value="map">{{ translations.settings.map.title }}</Tab>
        <Tab value="about">{{ translations.settings.about.title }}</Tab>
      </TabList>
      <TabPanels>
        <TabPanel class="settings-panel" value="general">
          <DarkModeToggle></DarkModeToggle>
          <LanguageSelect></LanguageSelect>
        </TabPanel>
        <TabPanel class="settings-panel" value="map">
          <MapColorMode></MapColorMode>
          <MapStyleSelect></MapStyleSelect>
        </TabPanel>
        <TabPanel class="settings-panel" value="about">
          <DisplayLogo></DisplayLogo>
          <VersionInfo></VersionInfo>
          <ReleaseNoteList v-model:model-value="notes"></ReleaseNoteList>
        </TabPanel>
      </TabPanels>
    </Tabs>
  </Dialog>
</template>

<style>
.settings-dialog {
  width: 80vw;
  height: 80vh;
}

.settings-panel {
  display: grid;
  grid-template-columns: 1fr;
  row-gap: 1rem;
}

</style>

<style>
.settings-dialog .p-dialog-content {
  overflow-y: hidden;
}

.settings-dialog .p-tabs {
  overflow-y: hidden;
  height: 100%;
  display: grid;
  grid-template-rows: auto 1fr;
}

.settings-dialog .p-tabpanels {
  overflow-y: auto;
}
</style>
